import { useCurrentUser } from '@framework/auth';
import { Dropdown } from '@framework/ui';
import { default as React } from 'react';
import { FrontUserButton } from './FrontUserButton';
import { LoginButton } from './LoginButton';
import { useUserMenuItems } from './useUserMenuItems';

export interface UserMenuProps {}
/**
 * Pulsante Dropdown per il logout dell'utente lato compilazione
 * Visualizza il nome dell'utente loggato.
 */
export function UserMenu(props: UserMenuProps) {
  const currentUser = useCurrentUser();
  const userMenuItem = useUserMenuItems();

  return currentUser ? (
    <Dropdown
      autoFocus
      placement="bottomRight"
      menu={userMenuItem}
      trigger={['click']}
    >
      <FrontUserButton currentUser={currentUser} />
    </Dropdown>
  ) : (
    <LoginButton />
  );
}
